import { render, staticRenderFns } from "./ReviewActivityDetailPanel.vue?vue&type=template&id=4fc15afa&"
import script from "./ReviewActivityDetailPanel.vue?vue&type=script&lang=js&"
export * from "./ReviewActivityDetailPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VNavigationDrawer,VSimpleTable})
